import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ProjectsCatalog Action/Mutation Types. Use it in   projects/actions.js, projects/mutations.js and the Vuex Host Component
export const ProjectsCatalogData = createActionTypeModel("ProjectsCatalogData");
export const ProjectList = createActionTypeModel("ProjectList");
export const ProjectDetails = createActionTypeModel("ProjectDetails");
export const ProjectRelatedContacts = createActionTypeModel(
  "ProjectRelatedContacts"
);
export const ProjectCosts = createActionTypeModel("ProjectCosts");

export const ProjectCostsLine = createActionTypeModel("ProjectCostsLine");
